import { Inject, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IReportWorkflowExamService } from '../report-workflow-exam.service';
import { EcgChartState } from '../../models/estensasign.model';
import { TokenStoreService } from '../../utils/token-interceptor/tokenstore.service';
import { TokenStoreInjector } from '../../utils/token-interceptor/token.interceptor';
import { BurnDataVNext, Burner } from '../../models/mps.models';
import { MPSService } from './mps.service';
import { VisitBaseService } from './base/visit-base.service';
import { AuthData } from '@se/models';

@Injectable({
    providedIn: 'root',
})
export class VisitService extends VisitBaseService implements IReportWorkflowExamService {
    private mpsService = inject(MPSService);

    constructor(
        @Inject(TokenStoreInjector) public tokenStore: TokenStoreService,
        protected httpClient: HttpClient,
    ) {
        super();
    }

    approve(
        reportIds: string[],
        authData?: AuthData,
        isDeferred = false,
        isFromWorklist?: boolean,
        displayedSettings?: EcgChartState,
        otherCredentialsData?: AuthData[],
        referringPhysicianId?: string,
    ) {
        let otherCredentials: string[] = [];
        if (otherCredentialsData && otherCredentialsData.length >= 1) {
            otherCredentialsData.forEach((credential) => {
                otherCredentials.push(this.encodeBase64(credential));
            });
        }

        return this.approveBase(
            reportIds,
            authData || null,
            otherCredentials,
            isDeferred,
            isFromWorklist,
            displayedSettings,
            referringPhysicianId,
        );
    }

    undoMultiValidation(reportId: string, authData: AuthData[], isFromWorklist?: boolean) {
        const otherCredentials = authData.slice(1).map((credentials) => this.encodeBase64(credentials));
        return this.undoMultiValidationBase(authData[0], reportId, otherCredentials, isFromWorklist);
    }

    burnCd(idExaminations: string[], burner?: Burner) {
        const burnData: BurnDataVNext = { burner: burner, clientName: '', mediaType: '', idExaminations };
        return this.mpsService.burnCd(burnData);
    }
}
